import React from "react";
import loadImage from "blueimp-load-image";
import IconStore from "./IconStore";
import "./index.css";
class AddTier2 extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      content: "",
      tier2_title: "",
      tier2_img_src: require("../../../assets/media/picture.png"),
      image_url: "",
      src: ""
    };
  }
  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onSelectImage = url => {
    this.setState({ image_url: url });
  };
  addTier2 = () => {
    const { addService } = this.props;
    const { image_url, tier2_title } = this.state;
    this.setState({ store_visible: false });
    console.log("image_url,tier2_title", image_url, tier2_title);
    addService(image_url, tier2_title);
  };
  render() {
    const { image_url, tier2_img_src, tier2_title, store_visible } = this.state;
    return (
      <div
        className="modal fade"
        id="add_Tier2"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add a new service branch</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="tier1_content">
              <label htmlFor="example-text-input">Tier2 Setting</label>
              <input
                type="text"
                name="tier2_title"
                value={tier2_title}
                className="form-control"
                placeholder="Input tier2 title.."
                onChange={this.onChange}
              />
              <button
                className="service_button"
                onClick={() => this.setState({ store_visible: true })}
              >
                <img
                  src={image_url ? image_url : tier2_img_src}
                  alt="tier2_img"
                  width="70"
                />
                <p>{tier2_title}</p>
              </button>
            </div>
            {store_visible && <IconStore onSelectImage={this.onSelectImage} />}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
                onClick={() => this.setState({ store_visible: false })}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
                onClick={() => {
                  if (tier2_title && image_url) this.addTier2();
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddTier2;



// WEBPACK FOOTER //
// ./src/screens/super_chatbots/components/AddTier2.js